<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    @closed="closeDialog"
    width="25%"
    center
    class="Dialog"
    title="文件描述"
  >
    <div class="dialog-content">
      <el-form :model="formData" ref="formRef" label-width="100px" class="demo-ruleForm">
        <el-form-item label="文件描述" prop="value">
          <el-input v-model="formData.value" placeholder="请输入文件描述"> </el-input>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 10px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 10px" @click="saveHandler">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'fileDescribe',
    data() {
      return {
        formData: { value: '' },
        visible: false,
        id: '',
      };
    },
    methods: {
      saveHandler() {
        this.visible = false;
        this.$emit('saveHandler', {
          id: this.id,
          fileDescription: this.formData.value,
        });
      },
      openDialog(id, value) {
        this.id = id;
        this.formData.value = value;
        this.visible = true;
      },
      closeDialog() {
        this.$refs.formRef?.resetFields();
      },
    },
  };
</script>

<style></style>
